<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="35%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="推荐供应商名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="recommendedSupplierName" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.recommendedSupplierName" placeholder="推荐供应商名称"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="项目经验" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="recommendedSupplierExpierence" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.recommendedSupplierExpierence" placeholder="项目经验"></el-input>
                    </el-form-item>
                </el-descriptions-item>

                <el-descriptions-item label="联系人" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="committeeContact" size="small">
                        <el-input style="float: left;width: 200px;" v-model="dataForm.committeeContact" placeholder="联系人"></el-input>
                        <!-- <span>{{dataForm.committeeContact}}</span>&nbsp;&nbsp; -->
                        <el-button  size="small" plain type="primary" @click="chooseCommitteeContact()">
                            选择
                        </el-button>
                    </el-form-item>
                </el-descriptions-item>

                <el-descriptions-item label="联系方式" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="contact" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.contact" placeholder="联系方式"></el-input>
                    </el-form-item>
                </el-descriptions-item>

            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="small" type="primary" plain @click="dataFormSubmit()" :loading="loading">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
        </el-button>
    </span>
    <div>
        <!-- 选择联系人 -->
        <common-user-dialog ref="commonUserDialog"></common-user-dialog>
    </div>
</el-dialog>
</template>

<script>
import {
    getSupplierById,
    createSupplier,
    editSupplier,
} from "@/controller/tech";
import {
    setLoading
} from "@/utils/index";
import { USER_TYPE, DIALOG_CLOSED_TYPE } from "@/utils/const";
import CommonUserDialog from "@/views/common/common-user-dialog";
export default {
    components: {
        CommonUserDialog,
    },
    data() {
        return {
            loading: false,
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            dataForm: {
                id: 0,
                recommendedSupplierName: "",
                recommendedSupplierExpierence: "",
                technicalId: "",
                committeeContact: "",
                contact: ""
            },
            // 开始
            dataRule: {
                // type: [
                //     {
                //         required: true,
                //         message: "编码类型不能为空",
                //         trigger: "blur",
                //     },
                // ],
            },
        };
    },
    methods: {
        init(id, technicalId) {
            this.dataForm.id = id || 0;
            this.dataForm.technicalId = technicalId;
            this.view.visible = true;
            this.loading = false
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    getSupplierById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let supplierParams = {
                        id: this.dataForm.id || undefined,
                        recommendedSupplierName: this.dataForm.recommendedSupplierName,
                        recommendedSupplierExpierence: this.dataForm.recommendedSupplierExpierence,
                        technicalId: this.dataForm.technicalId,
                        committeeContact: this.dataForm.committeeContact,
                        contact: this.dataForm.contact
                    };
                    if (this.dataForm.id) {
                        editSupplier(supplierParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.loading = false
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshSupplierDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createSupplier(supplierParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.loading = false
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshSupplierDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        //   选择委会联系人
        chooseCommitteeContact() {
            this.$refs.commonUserDialog.open(USER_TYPE.PERCHASE)
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // this.dataForm.partybCode = ''
                    this.dataForm.committeeContactId = payload.data.defaultPositionId
                    this.dataForm.committeeContact = payload.data.realName
                }
            };
        },
        getStyle() {
            return 'width: 140px; text-align: right'
        },
        getStyle2() {
            // return 'width: 243.5px;'
        }
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
